import { interval } from 'rxjs'
import { mergeMap, map, takeUntil, filter, startWith } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { ReduxAction, State } from '../../../reducers/reducerType'
import usernameLib from '../../../../lib/username'
import { roomTypes } from '../../../actions/room/roomTypes'
import { setupTypes } from '../../../actions/setup/setupTypes'
import { fetchPlayInList } from '../../../slices/playIn/playInSlice'
import { terminateGig } from '../../../actions/gig/gigActions'
import { ActionCreatorWithoutPayload } from '@reduxjs/toolkit'

const playInList$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType(setupTypes.SET_ROOM),
  filter(() =>
    state$.value.config.featureFlags.playIn &&
    usernameLib.isPresenter(state$.value.config.username || '') ||
    usernameLib.isObserver(state$.value.config.username || '')
  ),
  mergeMap(() => {

    return interval(10000).pipe(
      takeUntil(
        action$.pipe(
          ofType<
            ReduxAction<any> | ActionCreatorWithoutPayload<string>,
            any,
            string | roomTypes.TEAR_DOWN_ROOM_SUCCESS
          >(roomTypes.TEAR_DOWN_ROOM_SUCCESS, terminateGig().type)
        )
      ),
      startWith(() => fetchPlayInList(state$.value.config.roomname || '')),
      map(() => fetchPlayInList(state$.value.config.roomname || ''))
    )

  }

  )
)

export default playInList$
